import { createRouter, createWebHistory } from 'vue-router'
import SFWGallery from '../views/SFWGalleryView.vue'

const routes = [
  {
    path: '/',
    name: 'sfw',
    component: SFWGallery
  },
  {
    path: '/nsfw',
    name: 'nsfw',
    component: () => import('../views/NSFWGalleryView.vue')
  },
  {
    path: '/stickers',
    name: 'stickers',
    component: () => import('../views/StickersView.vue')
  },
  {
    path: '/references/anthro/sfw',
    name: 'references-anthro-sfw',
    component: () => import('../views/ReferencesAnthroSfwView.vue')
  },
  {
    path: '/references/anthro/nsfw',
    name: 'references-anthro-nsfw',
    component: () => import('../views/ReferencesAnthroNsfwView.vue')
  },
  {
    path: '/references/feral/sfw',
    name: 'references-feral-sfw',
    component: () => import('../views/ReferencesFeralSfwView.vue')
  },
  {
    path: '/references/feral/nsfw',
    name: 'references-feral-nsfw',
    component: () => import('../views/ReferencesFeralNsfwView.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFoundView.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router